'use strict';
import * as $i_$002fsrc$002fmain$002fjs$002fenv$002ejs from "/src/main/js/env.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dEn$0024 from "./io.intela.sites.intelacloud.content.-En$.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_SiteInfo$() {
  this.rE = null;
  this.rF = null;
  $n_Lio_intela_sites_intelacloud_SiteInfo$ = this;
  this.rE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_intela_sites_kit_seo_Organization("Intela", "Integrated Technology Laboratory LLC", "https://intela.io", "info@intela.io", "/brand/intela-logo.svg", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
  this.rF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_intela_sites_kit_seo_Site("Intela.cloud", $i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.siteUrl, $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dEn$0024.$m_Lio_intela_sites_intelacloud_content_En$().lM.fb, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Lio_intela_sites_kit_i18n_Locale$__En__Lio_intela_sites_kit_i18n_Locale(), this.rE, "/brand/og.png", "/brand/favicon.svg", (!(!$i_$002fsrc$002fmain$002fjs$002fenv$002ejs.env.noIndex)));
}
export { $c_Lio_intela_sites_intelacloud_SiteInfo$ as $c_Lio_intela_sites_intelacloud_SiteInfo$ };
$p = $c_Lio_intela_sites_intelacloud_SiteInfo$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_SiteInfo$;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_SiteInfo$() {
}
export { $h_Lio_intela_sites_intelacloud_SiteInfo$ as $h_Lio_intela_sites_intelacloud_SiteInfo$ };
$h_Lio_intela_sites_intelacloud_SiteInfo$.prototype = $p;
var $d_Lio_intela_sites_intelacloud_SiteInfo$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_SiteInfo$, "io.intela.sites.intelacloud.SiteInfo$", ({
  eJ: 1
}));
export { $d_Lio_intela_sites_intelacloud_SiteInfo$ as $d_Lio_intela_sites_intelacloud_SiteInfo$ };
var $n_Lio_intela_sites_intelacloud_SiteInfo$;
function $m_Lio_intela_sites_intelacloud_SiteInfo$() {
  if ((!$n_Lio_intela_sites_intelacloud_SiteInfo$)) {
    $n_Lio_intela_sites_intelacloud_SiteInfo$ = new $c_Lio_intela_sites_intelacloud_SiteInfo$();
  }
  return $n_Lio_intela_sites_intelacloud_SiteInfo$;
}
export { $m_Lio_intela_sites_intelacloud_SiteInfo$ as $m_Lio_intela_sites_intelacloud_SiteInfo$ };
//# sourceMappingURL=io.intela.sites.intelacloud.-Site-Info$.js.map
